import { ResetStateAction } from "components/curb/ManagerAnalyzer/Toggle/commonUtilities";
import { GetRequestInterface } from "../../../interfaces/ActionReducer/GetMethod/GetRequest";
import { ProposedRegulationReceived } from "../types";

export const SET_SELECTED_ROWS = "SET_SELECTED_ROWS";
export const GET_ALL_PROPOSED_REGULATIONS = "GET_ALL_PROPOSED_REGULATIONS";
export const ALL_PROPOSED_REGULATIONS_RECEIVED = "ALL_PROPOSED_REGULATIONS_RECEIVED";
export const PUBLISH_REGULATIONS = "PUBLISH_REGULATIONS";
export const DELETE_REGULATIONS = "DELETE_REGULATIONS";
export const EXPORT_REGULATIONS = "EXPORT_REGULATIONS";
export const SET_REGULATION_NAME = "SET_REGULATION_NAME";
export const GET_DATA_FOR_FILTERS = "GET_DATA_FOR_FILTERS";
export const DATA_FOR_FILTERS_RECEIVED = "GET_DATA_FOR_FILTERS_RECEIVED";
export const SELECTED_REGULATION_COLUMNS = "SELECTED_REGULATION_COLUMNS";
export const SET_PROPOSED_CHANGES_FILTER_PARAMS = "SET_PROPOSED_CHANGES_FILTER_PARAMS";
export const TOGGLE_ACTION_PERFORMED = "TOGGLE_ACTION_PERFORMED";
export const DELETE_PARKING_RATES_BATCH = "DELETE_PARKING_RATES_BATCH";

export type SelectedRows = number[];
export type Published = number[];
export type ParentLinkIds = number[];
export type RegulationName = string | number;
export type CurbLinkId = number[];

// Implemented a New typeScript Interface for SetRegulationName
export interface SetRegulationNameAction {
    type: typeof SET_REGULATION_NAME;
    payload: { regulationName: string };
}

export interface SelectedRowAction {
    type: typeof SET_SELECTED_ROWS;
    payload: {
        selectedRows: SelectedRows;
        isPublished: Published;
        parentLinkIds: ParentLinkIds;
        curbLinkId: CurbLinkId;
        actionsData: string[];
        batchIds: number[];
    };
}

export interface GetAllProposedRegulationsAction {
    type: typeof GET_ALL_PROPOSED_REGULATIONS;
    payload: { params: proposedChangesFilterParams };
}

export interface SelectedRegulationColumnAction {
    type: typeof SELECTED_REGULATION_COLUMNS;
    payload: { selectedColumns: string[] };
}

export interface AllProposedRegulationsReceivedAction {
    type: typeof ALL_PROPOSED_REGULATIONS_RECEIVED;
    payload: { allProposedRegulationsReceived: ProposedRegulationReceived };
}
export type AllProposedRegulationsReceived = ProposedRegulationReceived;
export type Filters = Array<{ [prop: string]: any }>;
export interface RegulationListViewState {
    selectedRowIds: SelectedRows;
    isPublished: Published;
    parentLinkIds: ParentLinkIds;
    curbLinkId: CurbLinkId;
    allProposedRegulations: AllProposedRegulationsReceived;
    isAllProposedRegulationsFetching: boolean;
    setRegulationName: RegulationName;
    filtersData: Filters;
    proposedChangesParams: proposedChangesFilterParams;
    actionPerformed: boolean;
    actionsData: string[];
    batchIds: number[];
    selectedColumns: string[];
}

export type RegulationIds = SelectedRows;
export interface PublishMultipleRegulationsAction {
    type: typeof PUBLISH_REGULATIONS;
    payload: {
        regulationIds: RegulationIds;
        batchIds?: any;
        afterPublish: () => void;
    };
}
export interface ExportRegulationsAction {
    type: typeof EXPORT_REGULATIONS;
    payload: {
        regulationIds: RegulationIds;
        mapDataURL: string;
        fields: string[];
        fileType: ExportFileType;
        getParams: proposedChangesFilterParams;
        afterExport: () => void;
    };
}

export interface DeleteRegulationsAction {
    type: typeof DELETE_REGULATIONS;
    payload: { regulationIds: RegulationIds; afterDelete: () => void };
}

export interface DeleteParkingRatesBatchAction {
    type: typeof DELETE_PARKING_RATES_BATCH;
    payload: { batch_ids: number[]; afterDelete: () => void };
}

export interface GetDataForFiltersAction {
    type: typeof GET_DATA_FOR_FILTERS;
    payload: { params: Partial<GetRequestInterface> };
}

export interface DataForFiltersReceivedAction {
    type: typeof DATA_FOR_FILTERS_RECEIVED;
    payload: { data: Filters };
}

export interface proposedChangesFilterParams {
    [index: string]: string | number | boolean | string[];
}
export interface SetProposedChangesFilterParamsAction {
    type: typeof SET_PROPOSED_CHANGES_FILTER_PARAMS;
    payload: { params: proposedChangesFilterParams };
}
export interface ToggleActionPerformedAction {
    type: typeof TOGGLE_ACTION_PERFORMED;
}
export type RegulationListViewTypes =
    | SelectedRowAction
    | SetRegulationNameAction
    | GetAllProposedRegulationsAction
    | AllProposedRegulationsReceivedAction
    | PublishMultipleRegulationsAction
    | ExportRegulationsAction
    | DeleteRegulationsAction
    | GetDataForFiltersAction
    | DataForFiltersReceivedAction
    | SetProposedChangesFilterParamsAction
    | ToggleActionPerformedAction
    | ResetStateAction
    | SelectedRegulationColumnAction;

export type ExportFileType = "excel" | "json" | "pdf";
